module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_M4-e05ed48962eba8ad0c6e341309f5ee2c.webp";